export const MIN_PASSWORD_LENGTH = 14;
export const MAX_PASSWORD_LENGTH = 128;

export interface PasswordCriteria {
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
}

export function getPasswordCriteria(password: string): PasswordCriteria {
  const pwd = password || "";
  return {
    hasMinLength: pwd.length >= MIN_PASSWORD_LENGTH,
    hasUppercase: /[A-Z]/.test(pwd),
    hasLowercase: /[a-z]/.test(pwd),
    hasNumber: /[0-9]/.test(pwd),
    hasSpecialChar: /[^A-Za-z0-9]/.test(pwd),
  };
}

export function validatePassword(password: string): {
  isValid: boolean;
  error?: string;
  criteria: PasswordCriteria;
} {
  const criteria = getPasswordCriteria(password);
  const isValid = Object.values(criteria).every(Boolean);

  let error: string | undefined;
  if (!password) {
    error = "Password is required";
  } else if (!criteria.hasMinLength) {
    error = `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`;
  } else if (!criteria.hasUppercase) {
    error = "Password must contain at least one uppercase letter";
  } else if (!criteria.hasLowercase) {
    error = "Password must contain at least one lowercase letter";
  } else if (!criteria.hasNumber) {
    error = "Password must contain at least one number";
  } else if (!criteria.hasSpecialChar) {
    error = "Password must contain at least one special character";
  }

  return { isValid, error, criteria };
}
